import type { CREDIT_NOTE_TABLE_COLUMNS, PROCESSED_TABLE_COLUMNS } from '@/constants';

type ProcessedTableColumn = (typeof PROCESSED_TABLE_COLUMNS)[number];
type CreditNoteTableColumn = (typeof CREDIT_NOTE_TABLE_COLUMNS)[number];

export type ColumnType = ProcessedTableColumn | CreditNoteTableColumn;

export type SortableColumn = Extract<
    ColumnType,
    CreditNoteSortableColumns | ProcessedOrderSortableColumns
>;

export enum CreditNoteSortableColumns {
    CreationDate = 'creationDate',
    PartnerName = 'partnerName',
    CreditNoteNumber = 'creditNoteNumber',
    ClientName = 'clientName',
}

export enum ProcessedOrderSortableColumns {
    IsConstruction = 'isConstruction',
    ChangedAt = 'changedAt',
}
